import React from "react";
import { HOME } from "@/constants/testIds";

export default function FinalCTA({ onBook }) {
  return (
    <section className="py-20 md:py-28" style={{ background: "var(--ev-blue)" }}>
      <div className="mx-auto max-w-[900px] px-5 md:px-10 text-center">
        <h2 className="font-serif-ev text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight text-white">
          Start your journey now.
        </h2>
        <p className="mt-6 text-white/90 text-[15px] md:text-lg max-w-xl mx-auto">
          Join thousands who've found calm, clarity and lasting change through live healing and
          manifestation coaching.
        </p>
        <div className="mt-10">
          <button
            data-testid={HOME.finalBookBtn}
            onClick={onBook}
            className="ev-btn ev-btn-cream"
          >
            Book a free session
          </button>
        </div>
      </div>
    </section>
  );
}
